<template>
  <div class="embed_jobs_head embed_jobs_with_style_1">
    <div class="embed_jobs_head2">
      <div class="embed_jobs_head3">
        <div id="rec_job_listing_div" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZohoCareers',
  mounted() {
    setTimeout(() => {
      window.rec_embed_js.load({
        widget_id: 'rec_job_listing_div',
        page_name: 'Bliss-Applications',
        source: 'CareerSite',
        site: 'https://wyperformance.zohorecruit.com',
        brand_color: '#6875E2',
        empty_job_msg: 'No current Openings'
      });
    }, 1000);
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// zoho-careers-view.vue